
import { Component, Prop, Vue } from 'vue-property-decorator';

export interface RecentPO {
  id: number;
  poNumber: string;
  supplierName: string;
  status: string;
}

@Component({})
export default class PORecentlyCreated extends Vue {
  @Prop({ default: () => [] }) public readonly orders!: RecentPO[];
}
